module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-lg-c10a0476.svg";